import { combineReducers } from 'redux';
import { authConstants } from '../constants';
import authReducer from './auth';
import adminReducer from './admin';
import userReducer from './user';
import couponReducer from './coupon';
import leadReducer from './lead';

const appRreducer = combineReducers({
    authReducer,
    adminReducer,
    userReducer,
    couponReducer,
    leadReducer
});

/**
 * for reset all state data after success logout
 */
const rootReducer = (state = {}, action) => {
    if (action.type === authConstants.LOGOUT_SUCCESS) {
        state = undefined;
    }
  
    return appRreducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js